Ext.define('SA.VectorMapOverlay', {
    alias: 'widget.vector-map-overlay',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-vector-map-overlay',

    items: [
        {
            xtype: 'boxed-spinner',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            cls: 'sa-vector-map-overlay-spinner',
            hidden: true
        }, {
            xtype: 'simple-container',
            itemId: 'messages',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-vector-map-overlay-message',
                    hidden: true,
                    html: 'Please zoom in to a location where you’ve uploaded your data.',
                    itemId: 'importMessage'
                }, {
                    xtype: 'component',
                    cls: 'sa-vector-map-overlay-message',
                    hidden: true,
                    itemId: 'dataVariationMessage',

                    html: [
                        'We are unable to generate a map legend because there is not enough variation in your data ',
                        '(for example, all or most locations have the same value).<br><br>',
                        'Please select a different data variable to display on your map.'
                    ]
                }, {
                    xtype: 'component',
                    cls: 'sa-vector-map-overlay-message',
                    hidden: true,
                    itemId: 'pointsMessage',

                    html: [
                        'There are too many matching businesses in this region to display.<br><br>',
                        'Please zoom in or pan to a less populated area to view business points.'
                    ]
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.dataVariationMessage = this.down('#dataVariationMessage');
        this.importMessage = this.down('#importMessage');
        this.pointsMessage = this.down('#pointsMessage');
        this.messages = this.down('#messages');
        this.spinner = this.down('boxed-spinner');
    },

    setLoading(loading) {
        this.spinner.setVisible(loading);

        this.messages.setVisible(!loading);
    },

    setModelState({hasLackOfDataVariation, hasUserAttributeWithoutUnitsAtCurrentScale}) {
        if (hasUserAttributeWithoutUnitsAtCurrentScale) {
            this.showMessage(this.importMessage);
        }
        else if (hasLackOfDataVariation) {
            this.showMessage(this.dataVariationMessage);
        }
        else {
            this.showMessage(null);
        }
    },

    setTooManyBusinessPoints() {
        this.showMessage(this.pointsMessage);
    },

    showMessage(message) {
        this.messages.items.forEach(item => item.setVisible(item === message));
    }
});